// extracted by mini-css-extract-plugin
export default {"block_loader":"Style_block_loader__uVPZ3","loader_inner":"Style_loader_inner__Gfe7a"};